import { RouteConfig } from "vue-router"
import { viewModule } from "../utils"

const paths: RouteConfig[] = [
  {
    path: '/courses',
    name: 'courses',
    component: viewModule('LMS'),
    meta: {
      section: 'courses'
    },
  },
  {
    path: '/courses/settings',
    name: 'lmsSettings',
    component: viewModule('LMS','Settings'),
    meta: {
      section: 'courses'
    },
  },
  {
    path: '/courses/analytics',
    name: 'lmsAnalytics',
    component: viewModule('LMS','Analytics'),
    meta: {
      section: 'courses'
    },
  },
  {
    path: '/courses/analytics/:user_id',
    name: 'lmsUserAnalytics',
    component: viewModule('LMS','UserAnalytics'),
    meta: {
      section: 'courses'
    },
  },
  {
    path: '/courses/new',
    name: 'courseNew',
    component: viewModule('LMS','Course'),
    meta: {
      section: 'courses'
    },
  },
  {
    path: '/courses/:id',
    name: 'courseEdit',
    component: viewModule('LMS','Course'),
    meta: {
      section: 'courses'
    },
  },
  {
    path: '/courses/:id/lessons/new',
    name: 'lessonNew',
    component: viewModule('LMS','LessonNew'),
    meta: {
      section: 'courses'
    },
  },
  {
    path: '/courses/:id/lessons/:lessonId',
    name: 'lessonEdit',
    component: viewModule('LMS','Lesson'),
    meta: {
      section: 'courses'
    },
  },
  {
    path: '/courses/:id/tests/new',
    name: 'testNew',
    component: viewModule('LMS','TestNew'),
    meta: {
      section: 'courses'
    },
  },
  {
    path: '/courses/:id/tests/:testId',
    name: 'testEdit',
    component: viewModule('LMS','Test'),
    meta: {
      section: 'courses'
    },
  }
]
export default paths